import React from 'react';
import { Heart, Star } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { testimonials } from '../../data/content';
export function TestimonialsSection() {
  return <section id="testimonios" className="bg-white py-16 md:py-[84px]" data-id="element-223" data-mp="1ru39uxz3i4se">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-224" data-mp="1mxctsanaj96z">
        <SectionHeading kicker="Testimonios" icon={Heart} title={<>
              Lo que dicen quienes <em data-id="element-226" data-mp="1dvdcdh8d633i">ya lo usan</em>
            </>} data-id="element-225" data-mp="1mui7seompgbg" />
        <ul className="no-scrollbar -mx-5 mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 md:mx-0 md:mt-11 md:grid md:grid-cols-2 md:gap-5 md:overflow-visible md:px-0 md:pb-0 lg:grid-cols-6" aria-label="Testimonios de compradores" data-id="element-227" data-mp="1dy9bv9zv0zu2">
          {testimonials.map((t, i) => <li key={t.name} className={`w-[85%] shrink-0 snap-center md:w-auto ${i < 3 ? 'lg:col-span-2' : 'lg:col-span-3'}`} data-id="element-228" data-mp="2ybzvy5tq87cv" data-mpi={i}>
              <Reveal delay={i * 0.04} className="flex h-full flex-col gap-4 rounded-[22px] border border-line bg-cream p-[26px]" data-id="element-229" data-mp="1tbq6llwmfbzh">
                <div className="flex gap-[3px]" role="img" aria-label="5 de 5 estrellas" data-id="element-230" data-mp="1jd0mrnl5zhgl">
                  {Array.from({
                length: 5
              }).map((_, s) => <Star key={s} className="h-[18px] w-[18px] text-tangerine" fill="currentColor" aria-hidden="true" data-id="element-231" data-mp="2bzlbega99fgg" data-mpi={s} />)}
                </div>
                <blockquote className="flex-1 text-[16.5px] leading-relaxed text-ink" data-id="element-232" data-mp="2h1ao00d4m16n">“{t.quote}”</blockquote>
                <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-233" data-mp="228h84dtxzj1g">
                  <span className="flex h-[46px] w-[46px] shrink-0 items-center justify-center rounded-full bg-forest font-display text-[15px] font-bold text-tangerine-light" aria-hidden="true" data-id="element-234" data-mp="277bol94fsvie">
                    {t.name.split(' ').map(p => p[0]).slice(0, 2).join('')}
                  </span>
                  <div data-id="element-235" data-mp="30k883v4cgzrl">
                    <b className="block font-display text-[15px] text-forest" data-id="element-236" data-mp="30jgaker6sryo">{t.name}</b>
                    <small className="text-[13.5px] text-muted" data-id="element-237" data-mp="2vl53gbsa0vk5">{t.location}</small>
                  </div>
                </div>
              </Reveal>
            </li>)}
        </ul>
        <p className="mt-3 text-center text-[13px] font-medium text-muted md:hidden" data-id="element-238" data-mp="2lv2agbl5nhlt">
          Desliza para ver más →
        </p>
      </div>
    </section>;
}